<script setup lang="ts">
import fail from '@/assets/icons/fail.svg';
import KycSessionLayout from '@/layout/KycSessionLayout.vue';
</script>

<template>
  <KycSessionLayout>
    <div class="flex flex-col" data-test="screen-kyc-failed">
      <img :src="fail" class="mb-3 size-16" />
      <h1 class="mb-4 text-3xl">Application unsuccessful</h1>
      <p class="text-light-secondary dark:text-dark-secondary mb-8">
        Your account verification hasn't been successful.
      </p>
      <p class="text-light-secondary dark:text-dark-secondary mb-16">
        If you have any questions reach out to support@immersve.com
      </p>
    </div>
  </KycSessionLayout>
</template>
